
const itemsHero = document.querySelectorAll(".hero__images__text");
if (itemsHero.length > 0) {
    let index = 0;

    function showNext() {
        itemsHero.forEach(el => el.classList.remove("active"));
        itemsHero[index].classList.add("active");
        index = (index + 1) % itemsHero.length;
    }

    showNext();
    setInterval(showNext, 3000);
}
    
